import React from 'react';
import { COLORS } from '../utils/constants.js';
import Spinner from '../components/Spinner.jsx';

export default function Campaigns({ sequences, addNotification, grConnected, ai }) {
  const { aiOutput, aiLoading, generateCampaign } = ai;

  const audiences = [
    { label: 'SaaS CTOs', desc: 'Technology decision-makers at SaaS companies' },
    { label: 'Startup Founders', desc: 'Early-stage startup founders seeking IT solutions' },
    { label: 'Enterprise IT Directors', desc: 'IT leaders at large corporations' },
    { label: 'Custom Audience', desc: 'Define your own target audience' },
  ];

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}><span style={{ color: COLORS.red }}>◈</span> Campaign Generator</h2>
      <p style={{ color: COLORS.textMuted, fontSize: 13, marginBottom: 20 }}>AI-generated email sequences for GetResponse or Apollo</p>

      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}`, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 600 }}>Generate Nurture Sequence</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 12, marginBottom: 14 }}>
          {audiences.map((a, i) => (
            <button key={i} onClick={() => generateCampaign(a.label === 'Custom Audience' ? 'custom B2B target' : a.desc)} disabled={aiLoading} style={{ padding: 16, borderRadius: 10, border: `1px solid ${COLORS.border}`, background: COLORS.surfaceAlt, color: COLORS.text, textAlign: 'left', cursor: aiLoading ? 'wait' : 'pointer', fontFamily: 'inherit' }}>
              <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: COLORS.accent }}>{a.label}</p>
              <p style={{ margin: '4px 0 0', fontSize: 12, color: COLORS.textMuted }}>{a.desc}</p>
            </button>
          ))}
        </div>
        {aiLoading && <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: COLORS.accent, fontSize: 13 }}><Spinner /> Generating...</div>}
      </div>

      {aiOutput && (
        <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.accent}44`, animation: 'fadeIn 0.3s ease', marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: 600, color: COLORS.accent }}>✦ Generated Campaign</h3>
          <pre style={{ margin: 0, padding: 16, borderRadius: 8, background: COLORS.bg, border: `1px solid ${COLORS.border}`, fontSize: 12, color: COLORS.textMuted, fontFamily: "'Space Mono', monospace", whiteSpace: 'pre-wrap', maxHeight: 400, overflowY: 'auto' }}>{aiOutput}</pre>
          <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
            <button onClick={() => addNotification(grConnected ? 'Ready to push to GetResponse!' : 'Connect GetResponse first', grConnected ? 'success' : 'error')} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.blue}, ${COLORS.blueDim})`, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Push to GetResponse</button>
          </div>
        </div>
      )}

      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
        <h3 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: 600 }}>Apollo Sequences</h3>
        {sequences.length === 0 ? <p style={{ fontSize: 13, color: COLORS.textMuted }}>No sequences in Apollo. Create them in Apollo's UI.</p> : sequences.map((s, i) => <div key={i} style={{ padding: 12, borderBottom: `1px solid ${COLORS.border}` }}><p style={{ margin: 0, fontWeight: 600 }}>{s.name}</p></div>)}
      </div>
    </div>
  );
}
